<template>
    <b-card>
        <b-form novalidate>
            <b-form-group
                id="detail_username_group_id"
                label="Nome de usuário"
                label-for="detail_username_id"
                description="Chave de acesso ao sistema"
            >
                <b-form-input
                    id="detail_username_id"
                    v-model="user.username"
                    required
                    placeholder="Nome de usuário..."
                    disabled
                />
            </b-form-group>
            <b-form-group
                id="detail_email_group_id"
                label="E-mail"
                label-for="detail_email_id"
            >
                <b-form-input
                    id="detail_email_id"
                    v-model="user.email"
                    type="email"
                    placeholder="E-mail..."
                    disabled
                />
            </b-form-group>
            <b-form-group
                id="detail_first_name_group_id"
                label="Nome"
                label-for="detail_first_name_id"
            >
                <b-form-input
                    id="detail_first_name_id"
                    v-model="user.first_name"
                    placeholder="Nome..."
                    disabled
                />
            </b-form-group>
            <b-form-group
                id="detail_last_name_group_id"
                label="Sobrenome"
                label-for="detail_last_name_id"
            >
                <b-form-input
                    id="detail_last_name_id"
                    v-model="user.last_name"
                    disabled
                    placeholder="Sobrenome..."
                />
            </b-form-group>
            <b-form-group
                id="detail_is_active_group_id"
                label-for="detail_is_active_id"
                label="Usuário ativo"
            >
                <i
                    v-b-tooltip.hover.left="
                        user.is_active
                            ? 'Acesso liberado.'
                            : 'Acesso bloqueado.'
                    "
                    :class="`far ${
                        user.is_active
                            ? 'fa-check-circle text-success'
                            : `fa-times-circle text-danger`
                    }`"
                />
            </b-form-group>
            <b-form-group
                id="detail_groups_group_id"
                label-for="detail_groups_id"
                label="Permissões de acesso"
            >
                <b-form-input id="detail_groups_id" :value="groups" disabled />
            </b-form-group>
            <b-form-group
                v-if="
                    user.groups.includes(dams.fozChapeco.GROUP_NAME) &&
                    fozChapecoPermissions
                "
                id="detail_fz_user_permissions_group_id"
                label-for="detail_fz_user_permissions_id"
                :label="`${dams.fozChapeco.GROUP_NAME} - Permissões especiais`"
            >
                <b-form-input
                    id="detail_fz_user_permissions_id"
                    :value="fozChapecoPermissions"
                    disabled
                />
            </b-form-group>
            <b-form-group
                v-if="
                    user.groups.includes(dams.camposNovos.GROUP_NAME) &&
                    camposNovosPermissions
                "
                id="detail_cn_user_permissions_group_id"
                label-for="detail_cn_user_permissions_id"
                :label="`${dams.camposNovos.GROUP_NAME} - Permissões especiais`"
            >
                <b-form-input
                    id="detail_cn_user_permissions_id"
                    :value="camposNovosPermissions"
                    disabled
                />
            </b-form-group>
            <b-form-group
                v-if="
                    user.groups.includes(dams.julho14.GROUP_NAME) &&
                    julho14Permissions
                "
                id="detail_j14_user_permissions_group_id"
                label-for="detail_j14_user_permissions_id"
                :label="`${dams.julho14.GROUP_NAME} - Permissões especiais`"
            >
                <b-form-input
                    id="detail_j14_user_permissions_id"
                    :value="julho14Permissions"
                    disabled
                />
            </b-form-group>
            <b-form-group
                v-if="generalPermissions"
                id="detail_general_user_permissions_group_id"
                label-for="detail_general_user_permissions_id"
                label="Permissões gerais"
            >
                <b-form-input
                    id="detail_general_user_permissions_id"
                    :value="generalPermissions"
                    disabled
                />
            </b-form-group>
        </b-form>
    </b-card>
</template>

<script>
import humanizeList from "@/utils/humanizeList";
import * as camposNovos from "@/modules/campos_novos/settings";
import * as fozChapeco from "@/modules/foz_chapeco/settings";
import * as julho14 from "@/modules/julho_14/settings";
import * as core from "@/modules/core/settings";

export default {
    name: "UsersDetail",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    computed: {
        groups() {
            if (this.user.is_superuser) {
                return "Administrador";
            }
            return humanizeList(this.user.groups);
        },
        dams() {
            return {
                camposNovos,
                fozChapeco,
                julho14
            };
        },
        fozChapecoPermissions() {
            return this.specialPermissionByDam(fozChapeco);
        },
        camposNovosPermissions() {
            return this.specialPermissionByDam(camposNovos);
        },
        julho14Permissions() {
            return this.specialPermissionByDam(julho14);
        },
        generalPermissions() {
            return this.specialPermissionByDam(core);
        }
    },
    methods: {
        specialPermissionByDam(dam) {
            const { SPECIAL_PERMISSIONS: specialPermissions } = dam;
            return humanizeList(
                specialPermissions
                    .filter(perm =>
                        this.user.user_permissions.includes(perm[0])
                    )
                    .map(perm => perm[1])
            );
        }
    }
};
</script>
